import CookieHelper from "base/CookieHelper";

class Ajax {

    static get(module, action, data) {
        return Ajax.request("GET", module, action, data);
    }

    static post(module, action, data) {
        return Ajax.request("POST", module, action, data);
    }

    static put(module, action, data) {
        return Ajax.request("PUT", module, action, data);
    }

    static patch(module, action, data) {
        return Ajax.request("PATCH", module, action, data);
    }

    static delete(module, action, data) {
        return Ajax.request("DELETE", module, action, data);
    }

    static request(method, module, action, data) {
        let cancelled = false;
        let promise;
        let jqXHR;
        const csrf = CookieHelper.get("csrf");

        if (method !== "GET") {
            if (!data) {
                data = {
                    csrf: csrf,
                };
            } else if (data instanceof FormData) {
                data.append("csrf", csrf);
            } else if ("object" === typeof data) {
                data = $.extend({
                    csrf: csrf,
                }, data);
            } else {
                //Noop Request will be rejected
            }
        }

        promise = new Promise((resolve, reject) => {
            jqXHR = $.ajax({
                url: (module !== null ? atob(window.CONFIG.restApiLocation) + module + "/" : "") + action,
                type: method,
                data: method === "GET" ? data : JSON.stringify(data),
                contentType: method === "GET" ? undefined : "application/json",
                dataType: "json",
                processData: !(data instanceof FormData),
            }).done((data) => {
                if (cancelled) {
                    return;
                }

                if ('undefined' === typeof data.headers) {
                    data.headers = this.process_header_string(jqXHR.getAllResponseHeaders());
                }

                resolve(data);
            }).fail((jqXHR) => {
                if (cancelled || page_unloading) {
                    return;
                }

                let data = jqXHR.responseJSON;
                let error;

                if ("object" === typeof data) {
                    error = new Error(data.message);
                    error.data = jqXHR.responseJSON;
                    error.reason = Ajax.API_ERROR;
                } else {
                    error = Ajax.get_ajax_error(jqXHR);
                }
                reject(error);
            });
        });

        Object.defineProperty(promise, "abort", {
            value: function () {
                cancelled = true;
                if (jqXHR) {
                    jqXHR.abort();
                }
                return this;
            },
        });

        return promise;
    }

    static process_header_string(string) {
        let headers = string.trim().split(/[\r\n]+/);

        let headerMap = {};
        headers.forEach(function (line) {
            let parts = line.split(': ');
            let header = parts.shift().toLowerCase();
            headerMap[header] = parts.join(': ');
        });

        return headerMap;
    }

    static get_ajax_error(jqXHR) {
        let message;
        let reason;
        let error;

        if (jqXHR.readyState === 0) {
            //Network error
            message = Ajax.defaultOptions.message.connectionError;
            reason = Ajax.CONNECTION_ERROR;
        } else if (jqXHR.readyState === 4) {
            message = Ajax.defaultOptions.message.internalError;
            reason = Ajax.SERVER_ERROR;
        } else {
            message = Ajax.defaultOptions.message.unknownError;
            reason = Ajax.SERVER_ERROR;
        }

        error = new Error(message);
        error.data = undefined;
        error.reason = reason;

        return error;
    }
}

Ajax.CONNECTION_ERROR = 1;
Ajax.SERVER_ERROR = 2;
Ajax.API_ERROR = 3;

Ajax.defaultOptions = {
    message: {
        connectionError: "A connection error occurred, please check your internet connection and try again.",
        internalError: "An internal server error occurred, please try again.",
        unknownError: "An unknown error occurred, please try again.",
    },
};


window.Ajax = Ajax;

let page_unloading = false;
$(window).on("beforeunload", () => {
    page_unloading = true;
});

export default Ajax;
